import { Grid2, Typography } from "@mui/material";
import useUIBp from "../../../Hooks/useUIBoilerplate";

const UIText = {
  "es-CL": { content: "Resetear contraseña" },
  "en-US": { content: "Reset password" },
};

const Header = () => {
  const { settings } = useUIBp();
  const { content } = UIText[settings.locale];

  return (
    <Grid2 container {...{ size: 12, justifyContent: "center" }}>
      <Typography
        {...{
          fontSize: "1.5rem",
          textTransform: "uppercase",
          component: "h1",
          variant: "h5",
        }}
      >
        {content}
      </Typography>
    </Grid2>
  );
};

export default Header;
